import { render } from "./ResendVerification.vue?vue&type=template&id=b04d1f84&scoped=true"
import script from "./ResendVerification.vue?vue&type=script&lang=js"
export * from "./ResendVerification.vue?vue&type=script&lang=js"

import "./ResendVerification.vue?vue&type=style&index=0&id=b04d1f84&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b04d1f84"]])

export default __exports__